/*
 * Public API Surface of ngx-lib/icon
 */
export * from './icon-registry.service';
export * from './icon.component';
export * from './icon.model';
export * from './icon.module';
